import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BaseModal from "./BaseModal";
import { clearSubsOrderDraft } from "../../redux/slices/SubscriptionDraftSlice";
import PrimaryBtn from "../button/PrimaryBtn";
import { Info } from "lucide-react";

const NewPlanadded = ({ open, onClose }) => {
  const isCreatOrderToday = localStorage.getItem("isToday");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subscribeDraft } = useSelector((state) => state.subscribeDraft);

  const toYYYYMMDD = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const handleContinue = () => {
    dispatch(clearSubsOrderDraft());
    navigate("/order");
  };

  return (
    <BaseModal open={open} onClose={onClose}>
      <div className="p-6 text-center space-y-4">
        <div
          className="h-10 w-10 rounded-full bg-[#FFEFEB] flex items-center justify-center cursor-pointer"
          onClick={onClose}
        >
          ✕
        </div>

        <h1>Subscription Started 🎉</h1>

        <p className="text-sm">
          You have successfully subscribed to <b>{subscribeDraft.meal.name}</b>
        </p>

        <p className="text-sm text-gray-500">
          Start date: {toYYYYMMDD(subscribeDraft.order.date)}
        </p>

        {isCreatOrderToday === "true" && (
          <div className="flex items-start gap-3 border border-red-200 bg-red-50 rounded-lg p-4">
            <Info className="w-5 h-5 text-red-500" />

            <div>
              <p className="text-sm text-red-500">
                Your first order will be created within 10 minutes.
              </p>
            </div>
          </div>
        )}

        <PrimaryBtn btnName="Continue" clickEvent={handleContinue} />
      </div>
    </BaseModal>
  );
};

export default NewPlanadded;
